import React, { useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import content from "../../content";
import { useSelector } from "react-redux";
import {
  getCart,
  getCartId,
  getHistory,
} from "../../reducers/project/selectors";
import useDesktop from "../../components/Responsive/useDesktop";

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  padding: 18px 32px;
  background-color: #121214;
  @media (max-width: 1024px) {
    height: 65px;
    padding: 14px 24px;
  }
`;

const StyledButton = styled(Button)`
  &.MuiButton-root {
    color: white;
    text-transform: unset;
    font-size: 14px;
    border: 1px solid #404347;
    letter-spacing: -0.01em;
    padding: 10px 16px;
  }

  @media (max-width: 1024px) {
    &.MuiButton-root > span > span {
      margin-right: 0px !important;
    }
  }
`;

function Header({}: IHeader) {
  const history = useSelector(getHistory);
  const cartId = useSelector(getCartId);
  const desktop = useDesktop();

  useEffect(() => {
    if (history.length !== 0) {
      window.localStorage.setItem("history", JSON.stringify(history));
    }
  }, [history]);

  useEffect(() => {
    if (cartId) {
      window.localStorage.setItem("cart", cartId);
    }
  }, [cartId]);

  return (
      <>
        <HeaderWrapper>
          <Link style={{
            color: '#efa21e'
          }} to={"/"}>
            {/*<img*/}
            {/*    alt={"header logo"}*/}
            {/*    src={"/static/img/private_logo_edited_1.png"}*/}
            {/*/>*/}
            KONFIGURATOR ROWERÓW
          </Link>
          {/*<div>*/}
          {/*  <Link to={"/cart"}>*/}
          {/*    <StyledButton*/}
          {/*        startIcon={*/}
          {/*          <img alt={"cart icon"} src={"/static/icon/cart.svg"} />*/}
          {/*        }*/}
          {/*        variant={"outlined"}*/}
          {/*    >*/}
          {/*      {desktop && content.getValue("clipboard")}*/}
          {/*    </StyledButton>*/}
          {/*  </Link>*/}
          {/*  <Link to={"/history"}>*/}
          {/*    <StyledButton*/}
          {/*        style={{ marginLeft: "16px" }}*/}
          {/*        startIcon={*/}
          {/*          <img alt={"time icon"} src={"/static/icon/time.svg"} />*/}
          {/*        }*/}
          {/*        variant={"outlined"}*/}
          {/*    >*/}
          {/*      {desktop && content.getValue("project_history")}*/}
          {/*    </StyledButton>*/}
          {/*  </Link>*/}
          {/*</div>*/}
        </HeaderWrapper>
      </>
  );
}

export interface IHeader {}

export default Header;
